export * from './consent.tmpl';
export * from './features.tmpl';
export * from './footer.tmpl';
export * from './group.tmpl';
export * from './template.tmpl';
export * from './viewTemplate.tmpl';
export * from './tooltip.tmpl';
export * from './link.tmpl';
export * from './em.tmpl';
export * from './comsParagraph.tmpl';
export * from './comsText.tmpl';
export * from './mergeAccountsWrapper.tmpl';
export * from './tefComsCustomerAttribute.tmpl';
